import { message } from 'antd';
import i18n from '../i18n';
import { postWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const handleCreateHealthmetricType = async (data: any, onOk?: () => void) => {
  console.log('handleCreateHealthmetricType data', data);
  if (!data) return;

  try {
    const response = await postWithCSRF(envApiUrl + '/healthmetrictypes', data);
    console.log('Create healthmetrictypes: response: ', response);
    message.success(i18n.t('healthMetric.healthmetricTypeCreated'));
    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('healthmetrictypes error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || i18n.t('healthMetric.healthmetricTypeCreateFailed'));
  }
};
